<template>
  <div class="policy">
    <img src="../assets/xihu/banner.png" style="width:100%" />
    <div style="padding: 0px 10px">
      <img class="mid" src="../assets/xihu/phdtxt.png" style="width:100%"/>
    </div>
	<div class="btnof">
		<a href="./word/fj1.docx" download="南通各地博士后政策简编.docx"><img src="../assets/xihu/bnt1.png"/></a>
		<a href="./word/fj2.docx" download="2024年南通市博士后设站单位博士后研究人员需求计划表.docx"><img src="../assets/xihu/btn2.png"/></a>
	</div>
    <div class="foot">Copyright © 51job. All Rights Reserved.</div>
    <BackHome/>
     <!-- ai -->
     <div class="aifc" @click="$router.push('/ai')">
        <img src="../assets/xihu/ai.png" />
    </div>

  </div>
</template>

<script>
import BackHome from '../components/BackHome'
export default {
  name: "Phd",
  components:{
    BackHome
  }
};
</script>

<style lang="scss" scoped>
.policy {
  padding: 8px;
  overflow: scroll;
  height: 100%;
  line-height: 35px;
  .btnof{
  	width:480px;
	margin:0 auto;
	a{
		display:block;
		margin-top:30px;
		img{
			width:100%;
		}
	}

  }
}

.title_li {
  width: 410px;
  height: 40px;
  color: #333;
  font-size: 33px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  margin: 72px auto 0px;
  img {
    display: inline-block;
    width: 41px;
    position: relative;
    top: 10px;
    height: 16px;
  }
}
.mid {
  display: block;
  margin: 20px auto;
}
article {
  color: #666666;
  p {
    text-indent: 2em;
    margin-bottom: 20px;
  }
}
.newpolicy {
  width: 350px;
  line-height: 70px;
  font-size: 29px;
  text-align: center;
  margin: 50px auto;
  display: block;
  background-color: #15BD87;
  color: #fff;
  border-radius: 5px;
  img {
    display: inline-block;
    margin-right: 14px;
  }
}
.foot {
  font-size: 20px;
  margin: 50px 0;
  color: #999999;
  text-align: center;
}
.tip {
  color: #000;
  text-align: center;
  margin-top: 20px;
  font-size: 12px;
}
.aifc{
  position: absolute;
  top: 20%;
  right: 0;
  z-index: 99999;
}
.aifc img{
  width: 3rem;
}
</style>